var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"message-box",class:{hide: _vm.hide, warning:_vm.isWarning}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }